// src/components/IllustrativeExample.jsx

import React, { memo } from "react";
import PropTypes from "prop-types";
import { MathJax, MathJaxContext } from "better-react-mathjax";

/**
 * MathJax v3 config:
 *  - Only display math ($$…$$ or \[ … \]) is enabled.
 *  - Container-aware line breaking keeps formulas within the card.
 */
const mathJaxConfig = {
  loader: { load: ["input/tex", "output/chtml"] },
  tex: {
    inlineMath: [],
    displayMath: [
      ["$$", "$$"],
      ["\\[", "\\]"],
    ],
    processEscapes: true,
  },
  chtml: { linebreaks: { automatic: true, width: "container" } },
};

function IllustrativeExample({ example, className = "" }) {
  const content = typeof example === "string" ? example : String(example ?? "");

  return (
    <MathJaxContext version={3} config={mathJaxConfig}>
      <section
        className={["illustrative-card", className].join(" ")}
        aria-label="Illustrative Example"
        role="region"
      >
        <div className="illustrative-mathwrap">
          <MathJax dynamic hideUntilTypeset="first">
            {content}
          </MathJax>
        </div>
      </section>
    </MathJaxContext>
  );
}

IllustrativeExample.propTypes = {
  example: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
};

export default memo(IllustrativeExample);
